import * as React from "react";
import type { SVGProps } from "react";
const SvgAiMessageSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="url(#ai-message-small_svg__a)"
      d="M8 1.547c.499 0 .978.058 1.437.155a.5.5 0 0 1-.207.979c-.4-.085-.81-.134-1.23-.134-3.073 0-5.5 2.25-5.5 4.954 0 1.603.847 3.031 2.182 3.943a.5.5 0 0 1 .217.414v1.335l1.632-.807.106-.038a.5.5 0 0 1 .227-.001q.552.107 1.136.108c3.073 0 5.5-2.25 5.5-4.954a4.3 4.3 0 0 0-.075-.772.5.5 0 0 1 .984-.177c.055.302.091.62.091.949 0 3.347-2.97 5.954-6.5 5.954a7 7 0 0 1-1.175-.1l-2.203 1.093A.5.5 0 0 1 3.9 14v-1.888c-1.449-1.08-2.4-2.73-2.4-4.611 0-3.347 2.97-5.954 6.5-5.954m4.666.12c.244 0 .468.133.585.347l.26.474.475.26a.667.667 0 0 1 0 1.17l-.475.26-.26.475a.667.667 0 0 1-1.17 0l-.26-.475-.474-.26a.667.667 0 0 1 0-1.17l.474-.26.26-.474a.67.67 0 0 1 .585-.347m-.26 1.142a.67.67 0 0 1-.264.264l-.476.26.476.26a.67.67 0 0 1 .264.265l.26.475.26-.475a.67.67 0 0 1 .265-.265l.475-.26-.475-.26a.67.67 0 0 1-.265-.264l-.26-.476z"
    />
    <defs>
      <linearGradient
        id="ai-message-small_svg__a"
        x1={-0.434}
        x2={20.073}
        y1={16.503}
        y2={2.039}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAiMessageSmall;
